module.exports = "query GetPhoneNumberCountries {\n  phoneNumberCountries {\n    ...PhoneNumberCountryFragment\n  }\n}\n"